import { Component, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'myrtls-reset-device-care-settings-modal',
    templateUrl: './reset-device-care-settings.modal.html',
    styleUrls: ['./reset-device-care-settings.modal.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
// eslint-disable-next-line @angular-eslint/component-class-suffix
export class ResetDeviceCareSettingsModal {
    resetDeviceCareSettingsForm = new UntypedFormGroup({});

    constructor(public dialogRef: MatDialogRef<string>) {}

    resetSettings() {
        this.dialogRef.close(true);
    }
}
